import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { HeroArchitecture } from './hero/HeroArchitecture';
import { heroSupporting } from '../data/heroContent';
const EASE = [0.23, 1, 0.32, 1] as const;
const reveal = (delay: number) => ({
  initial: {
    opacity: 0,
    y: 16
  },
  animate: {
    opacity: 1,
    y: 0
  },
  transition: {
    duration: 0.5,
    delay,
    ease: EASE
  }
});
export function Hero() {
  const {
    lang
  } = useLanguage();
  const isFR = lang === 'FR';
  return <section className="relative bg-white overflow-hidden" data-id="element-3704" data-mp="sb1c3rh88373">
      {/* Far-right community photograph, heavily faded into white */}
      <div className="pointer-events-none absolute inset-y-0 right-0 hidden lg:block w-[32%] max-w-[520px]" aria-hidden="true" data-id="element-3705" data-mp="nbexpepnwgwp">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/d17bcb6a-e953-4546-9c4e-7fad1541bb12.jpg" alt="" className="w-full h-full object-cover opacity-[0.22]" style={{
        maskImage: 'linear-gradient(to right, transparent 0%, black 55%, black 100%)',
        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 55%, black 100%)'
      }} data-id="element-3706" data-mp="382fedm0930dv" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 pt-32 lg:pt-40 pb-16 lg:pb-20" data-id="element-3707" data-mp="3ebiripnc9g44">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] gap-14 lg:gap-14 items-center" data-id="element-3708" data-mp="30ggap7gye6cj">
          {/* LEFT — message */}
          <div className="relative z-10" data-id="element-3709" data-mp="2qkdcgcp82ruv">
            <motion.div {...reveal(0)} data-id="element-3710" data-mp="2qlepuntpnqfr">
              <span className="block w-10 h-0.5 bg-[#4F46E5] mb-5" aria-hidden="true" data-id="element-3711" data-mp="2viy4houbm588" />
              <p className="font-sans text-xs font-semibold tracking-[0.22em] text-[#5B6478] uppercase" data-id="element-3712" data-mp="2hk8685vrlzia">
                {isFR ? 'L’intelligence de confiance intégrée à vos opérations' : 'Trusted intelligence built into your operations'}
              </p>
            </motion.div>

            <motion.h1 {...reveal(0.06)} className="font-serif text-5xl md:text-6xl lg:text-[4rem] font-normal leading-[1.05] tracking-tight mt-7 lg:whitespace-nowrap" data-id="element-3713" data-mp="n9qira2x6u7y">
              <span className="block text-[#121212]" data-id="element-3714" data-mp="deyj80ps1xaj">
                {isFR ? 'Plus de capacité.' : 'More capacity.'}
              </span>
              <span className="block text-[#4F46E5]" data-id="element-3715" data-mp="1622jjsdxdnfz">
                {isFR ? 'Moins de complexité.' : 'Less complexity.'}
              </span>
            </motion.h1>

            <motion.p {...reveal(0.12)} className="font-sans text-lg text-[#121212]/70 leading-relaxed max-w-[40rem] mt-8" data-id="element-3716" data-mp="114swukhx7pvu">
              {isFR ? heroSupporting.fr : heroSupporting.en}
            </motion.p>

            <motion.div {...reveal(0.24)} className="flex flex-wrap items-center gap-4 mt-9" data-id="element-3717" data-mp="3hr3rrvrkeb5t">
              <Link to="/request-demo" className="inline-flex items-center gap-2 px-7 py-4 bg-[#4F46E5] text-white font-sans text-sm font-medium hover:bg-[#4338CA] transition-colors duration-200" data-id="element-3718" data-mp="1xb5pse406rg4">
                {isFR ? 'Demander une démo' : 'Request a demo'}
                <ArrowRightIcon className="w-4 h-4" strokeWidth={2} data-id="element-3719" data-mp="2b2smug5rs3zy" />
              </Link>
            </motion.div>

            <motion.p {...reveal(0.3)} className="font-sans text-xs text-[#5B6478] tracking-wide mt-8" data-id="element-3720" data-mp="2g2566qxfmsxs">
              {isFR ? 'Identité sécurisée · IA agentique · Données souveraines · Résultats concrets' : 'Secure identity · Agentic AI · Sovereign data · Real results'}
            </motion.p>
          </div>

          {/* RIGHT — architecture at a glance */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.14,
          ease: EASE
        }} className="relative z-10" data-id="element-3721" data-mp="zkr8ym4s5k9y">
            <HeroArchitecture isFR={isFR} data-id="element-3722" data-mp="3vh5m6d05fiad" />
          </motion.div>
        </div>
      </div>
    </section>;
}